import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import IconButton from "../../../../../_components/IconButton";
import styled from "styled-components";

import * as colors from "../../../../../assets/_base/colors"

const Line = styled.hr`
  background-color: ${colors.lightBlue} !important;
  width: 20px;
  height: 1px;
  border-radius: 20px;
`;

export default (props) => {
  const [show, setShow] = React.useState(false);

  function onHide() {
    if (props.onHide) {
      props.onHide();
    }
    setShow(false);
  }

  function onHandleShow() {
    if (props.show) {
      if (props.show === true) {
        setShow(true);
      } else {
        setShow(false);
      }
    } else {
      setShow(false);
    }
  }
  React.useEffect(onHandleShow, [props.show]);

  return (
    <SweetAlert
      show={show}
      type={props.type || "success"}
      showCancel={props.showCancel}
      showConfirm={false}
      onCancel={null}
      onConfirm={null}
      title={
        <div>
          <div data-cy-test="#nfe-issuer-title-of-generic-alert" className="h2">{props.title}</div>
        </div>
      }
    >
      {props.children}
      <div className="d-flex justify-content-center">
        <div>
          <Line />
          {props.textButton ? (
            <h2
              disabled={props.disabled}
              style={{ color: 'black', cursor: 'pointer' }}
              onClick={onHide}
            >
              Clique <a href="/nfe/issuer">aqui</a> para recarregar página
            </h2>
          ) : (
            !props.hideClose && (
              <IconButton
                disabled={props.disabled}
                onClick={onHide}
                icon="times text-danger"
              />
            )
          )}

        </div>
      </div>
    </SweetAlert>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Dialog/index.jsx